import PaginationRequestData from '@/calendesk/models/DTO/Request/PaginationRequestData'

export default class SimpleStoreProductTransactionRequestData extends PaginationRequestData {

}
